import { useState } from 'react';
import { couponService } from '../services/couponService';

/**
 * Hook customizado para gerenciar cupons de desconto
 */
export const useCoupon = () => {
  const [couponCode, setCouponCode] = useState('');
  const [couponData, setCouponData] = useState(null);
  const [pricing, setPricing] = useState(null);
  const [isValidating, setIsValidating] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Validar cupom
   * @param {string} code - Código do cupom
   * @param {number} planId - ID do plano
   */
  const validateCoupon = async (code, planId) => {
    if (!code || !code.trim()) {
      setError('Digite um código de cupom');
      return { success: false };
    }

    if (!planId) {
      setError('Selecione um plano primeiro');
      return { success: false };
    }

    setIsValidating(true);
    setError(null);

    try {
      const response = await couponService.validateCoupon(code.toUpperCase(), planId);
      
      if (response.success) {
        setCouponCode(code.toUpperCase());
        setCouponData(response.data.coupon);
        setPricing(response.data.pricing);
        return { success: true, data: response.data };
      } else {
        setError(response.error || 'Cupom inválido');
        return { success: false, error: response.error };
      }
    } catch (err) {
      const errorMessage = err.response?.data?.error || 
                          err.response?.data?.message || 
                          'Erro ao validar cupom';
      setError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setIsValidating(false);
    }
  };

  /**
   * Remover cupom aplicado
   */
  const removeCoupon = () => {
    setCouponCode('');
    setCouponData(null);
    setPricing(null);
    setError(null);
  };

  /**
   * Resetar estado do cupom
   */
  const resetCoupon = () => {
    removeCoupon();
  };

  return {
    couponCode,
    couponData,
    pricing,
    isValidating,
    error,
    validateCoupon,
    removeCoupon,
    resetCoupon,
    hasCoupon: !!couponData
  };
};
